export enum SupervisorRoleTypes {
  CHIEF_SUPERVISOR = 'CHIEF_SUPERVISOR', // just for Chief Supervisor

  CO_SUPERVISOR = 'CO_SUPERVISOR',
  EXTERNAL_CO_SUPERVISOR = 'EXTERNAL_CO_SUPERVISOR',
  EXTERNAL_CHIEF_JOINT = 'EXTERNAL_CHIEF_JOINT', // Joint External Chief Supervisor
  EXTERNAL_CHIEF_DUAL = 'EXTERNAL_CHIEF_DUAL', // Dual External Chief Supervisor

  // MOD 2024/09/26, keep for compatibility with older data in supervisor team section
  EXTERNAL_CHIEF_SUPERVISOR = 'EXTERNAL_CHIEF_SUPERVISOR',
}

export enum SupervisorRoleDBTypes {
  /**
   * @deprecated Use the programme type related ones instead.
   */
  EXTERNAL_CHIEF_SUPERVISOR = 'EXTERNAL_CHIEF',

  /**
   * @description The chief supervisor of a programme, must have and can have one in each nomination.
   */
  CHIEF_SUPERVISOR = 'CHIEF',

  /**
   * @description The co-supervisor of a programme, can have multiple in each nomination.
   */
  CO_SUPERVISOR = 'CO',

  /**
   * @description The external chief supervisor of a programme.
   */
  EXTERNAL_CO_SUPERVISOR = 'EXTERNAL_CO',

  /**
   * @description The external co-supervisor of a programme for Joint programme.
   */
  EXTERNAL_CHIEF_JOINT = 'EXTERNAL_CHIEF_JOINT',

  /**
   * @description The external co-supervisor of a programme for dual programme.
   */
  EXTERNAL_CHIEF_DUAL = 'EXTERNAL_CHIEF_DUAL',
}
